<!-- Professional Diary Modal with True Viewport Centering -->
<div class="modal fade show" role="dialog" style="display: block; background: rgba(0,0,0,0.5); position: fixed; top: 0; left: 0; width: 100%; height: 100vh; z-index: 1055;">
  <div class="modal-dialog" role="document" style="max-width: 70%; width: 70%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); margin: 0;">
    <div class="modal-content">
      <!-- Professional Header -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="icon-calendar"></i>{{data?.title || 'Events'}}
        </h5>
        <button type="button" class="close" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Scrollable Body with Dynamic Height -->
      <div class="modal-body">
        <div class="modal-content-body" [ngClass]="{'modal-scroll-enabled': diaryData?.length > 0}">

          <!-- Scroll Indicator for Large Lists -->
          <div class="diary-scroll-indicator" *ngIf="diaryData && diaryData.length > 8">
            <i class="icon-list"></i>
            {{diaryData.length}} Events - Scroll to view all
          </div>

          <!-- Loading State -->
          <div class="diary-loading" *ngIf="!diaryData || diaryData.length === 0">
            <i class="icon-clock"></i>
            <h4>Loading Events...</h4>
          </div>

          <!-- Empty State -->
          <div class="diary-empty" *ngIf="diaryData && diaryData.length === 0">
            <i class="icon-calendar"></i>
            <h4>No Events Found</h4>
            <p>There are no events scheduled for this date.</p>
          </div>

          <!-- Event List with Professional Cards -->
          <div class="diary-event-item" *ngFor="let diary of diaryData; let i = index">
            <!-- Event Header -->
            <div class="diary-event-header">
              <a class="diary-title" (click)="routeToCase(diary.id)">
                <i class="icon-badge"></i>{{diary.name || 'Event ' + (i + 1)}}
              </a>
            </div>

            <!-- Event Details Grid -->
            <div class="diary-event-details">
              <!-- Left Column - Event Information -->
              <div class="diary-event-info">
                <div class="info-item" *ngIf="diary.courtName && diary.courtTime">
                  <i class="icon-location-pin"></i>
                  <strong>Court:</strong>
                  <span>{{diary.courtName}} at {{diary.courtTime}}</span>
                </div>

                <div class="info-item" *ngIf="diary.courtDate">
                  <i class="icon-calendar"></i>
                  <strong>Date:</strong>
                  <span>{{diary.courtDate | date : 'dd-MM-yyyy'}}
                    <span class="text-colored" *ngIf="diary.endDate && diary.courtDate !== diary.endDate">
                      to {{diary.endDate | date : 'dd-MM-yyyy'}}
                    </span>
                  </span>
                </div>

                <div class="info-item" *ngIf="diary.solicitor?.companyName">
                  <i class="icon-briefcase"></i>
                  <strong>Solicitor:</strong>
                  <span>{{diary.solicitor.companyName}}</span>
                </div>

                <div class="info-item" *ngIf="diary.client">
                  <i class="icon-user"></i>
                  <strong>Client:</strong>
                  <span>{{diary.client.clientFname}} {{diary.client.clientLname}}</span>
                </div>

                <div class="info-item" *ngIf="diary.barristerName">
                  <i class="icon-people"></i>
                  <strong>Barrister:</strong>
                  <span>{{diary.barristerName}}</span>
                </div>

                <div class="info-item" *ngIf="diary.claimant && diary.defendant">
                  <i class="icon-direction"></i>
                  <strong>Parties:</strong>
                  <span>{{diary.claimant}} -vs- {{diary.defendant}}</span>
                </div>

                <div class="info-item" *ngIf="diary.behalfOf">
                  <i class="icon-trophy"></i>
                  <strong>Behalf Of:</strong>
                  <span>{{diary.behalfOf}}</span>
                </div>
              </div>

              <!-- Right Column - Status Badges -->
              <div class="diary-status-section">
                <div class="status-badges">
                  <!-- Status badges in single column -->
                  <div class="status-badges-list">
                    <div *ngIf="data.type != 'upcomingHearings' && diary.attendanceColor">
                      <span class="badge badge-{{diary.attendanceColor}} mb-1 clickable-badge" (click)="toggleStatusConfirmation(diary)">Attendance Note Due</span>
                    </div>
                    <div *ngIf="data.type == 'upcomingHearings' && diary.advancePaymentColor && diary.advancePayment">
                      <span class="badge badge-{{diary.advancePaymentColor}} mb-1">{{diary.advancePayment}}</span>
                    </div>
                    <div *ngIf="data.type == 'upcomingHearings' && diary.statusColor && diary.statusText">
                      <span class="badge badge-{{diary.statusColor}} mb-1">{{diary.statusText}}</span>
                    </div>
                    <div *ngIf="diary.listingColor">
                      <span class="badge badge-{{diary.listingColor}} mb-1 clickable-badge" (click)="toggleStatusConfirmation(diary)">Court Listing Due</span>
                    </div>
                    <div *ngIf="diary.additionalWorkName && diary.additionalWorkName.trim() && diary.additionalColor">
                      <span class="badge badge-{{diary.additionalColor}} mb-1">{{diary.additionalWorkName}}</span>
                    </div>
                    <div *ngIf="diary.bundleColor">
                      <span class="badge badge-{{diary.bundleColor}} mb-1 clickable-badge" (click)="toggleStatusConfirmation(diary)">Court Bundle Due</span>
                    </div>
                    <div *ngIf="diary.outstandingDocuments && diary.outstandingDocuments.trim() && diary.outstandingColor && diary.outstandingDocumentName">
                      <span class="badge badge-{{diary.outstandingColor}} mb-1">{{diary.outstandingDocumentName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Button -->
            <div class="diary-event-action">
              <button type="button" class="btn-view-case" (click)="routeToCase(diary.id)">
                <i class="icon-eye"></i>View Case
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Professional Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="closeModal()">
          <i class="icon-close mr-1"></i>Close
        </button>
      </div>
    </div>
  </div>
</div>
